(function ()
{
    function findHost(empty) {
        const sel = empty.getAttribute('data-empty-target');
        if (sel) return document.querySelector(sel);
        // fallback : un frangin marqué comme host
        const siblingHost = empty.parentElement?.querySelector('[data-empty-host]');
        return siblingHost || null;
    }

    function createDemoItem(idx = 1) {
        const item = document.createElement('div');
        item.className = 'list__item';
        item.innerHTML = `
      <div class="list__leading">${idx}</div>
      <div>
        <div class="list__title">Nouvel élément #${idx}</div>
        <div class="list__subtitle">Créé depuis l’empty state</div>
      </div>
      <div class="list__trailing">now</div>
    `;
        return item;
    }

    document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-empty-add]');
        if (!btn) return;

        const empty = btn.closest('[data-empty]');
        if (!empty) return;

        const host = findHost(empty);
        if (!host) return;

        // si la liste était cachée, on la montre et on masque l'empty
        if (host.hasAttribute('hidden')) host.removeAttribute('hidden');
        empty.setAttribute('hidden', '');

        // Ajout d’un item démo (utilise .list existante)
        const count = host.querySelectorAll('.list__item').length;
        host.appendChild(createDemoItem(count + 1));
    });
})();
